<script>
import Faq from "@/components/Faq.vue";
const Hero = () => import("@/components/media/Hero.vue");
export default {
  name: "faq",
  data() {
    return {};
  },
  components: {
    Hero,
    Faq
  },
  computed: {},
  methods: {
    sendToLogin() {
      this.$store.commit("user/SET_NEXT_ROUTE", { path: "/vagas" });
      this.$store.commit("DEVISE_FORM", "login");
    },
  }
};
</script>

<template>
  <section class="faq">
    <Hero
      title=""
      :image="'faq.png'"
      :search="false"
      layout="md"
    />
    <div>
      <div class="row" id="faq">
        <div class="col-10 mx-auto">
          <h1>Perguntas</h1><h1 class="t">Frequentes</h1>
          <Faq />
          <h4>Partiu futuro?</h4>
        </div>
      </div>
      <div class="cadastro">
        <div class="c-tittle"><h1>Venha trabalhar</h1><h1 class="d">com a gente</h1></div>
        <div class="c-button">
          <button
            type="button"
            style="border:none"
            @click="sendToLogin()"
          >
          Quero me inscrever
          </button></div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.faq{
  font-family: 'Bw Gradual DEMO';

  #faq{
    padding: 40px 0;

    div{
      text-align: center;
      h1{
        line-height: 68px;
        letter-spacing: 0em;
        color: #0A1D6F;
        margin-bottom: 40px;
        display: inline-block;
      }
      .t{
        color: #00CFD9;
        margin-left: 10px;
        font-weight: 700;
      }

      h4{
        color: #00CFD9;
        font-style: italic;
        font-weight: bold;
        margin: 70px 0 4px 0;
      }
    }
  }
    .cadastro{
      background: linear-gradient(0deg, rgba(217, 217, 217, 0.2), rgba(217, 217, 217, 0.2)), #FFFFFF;;
      margin-right: -15px;
      margin-left: -15px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .c-tittle{
        display: flex;
        color: #0A1D6F;
        justify-content: center;
        margin-top: 40px;

        .d{
          color: #00CFD9;
          margin-left: 10px;
          font-weight: bold;
        }
      }

      .c-button{
        text-align: center;
        margin-bottom: 80px;
        margin-top: 10px;
        button{
          background-color: theme-color('color-1');
          padding: 6px 30px;
          color: #00CFD9;
          border-radius: 30px;
        }
      }

      @include media-breakpoint-down(sm){
        h1{
          font-size: 25px;
        }
      }
    }


    /deep/{
      .faq .list-group-item .btn{
        color: #0A1D6F;
        font-size: 18px;
        font-weight: bold;
      }

      .faq .list-group-item{
        border: none;
        border-bottom: 2px solid #eaeaea;
      }

      .faq .list-group-item .collapse-content p{
        color: #0A1D6F;
        font-size: 18px;
        font-family: 'Bw Gradual DEMO';
      }
  }

}
</style>
